<template>
  <swiper
    class="swiper-container"
    :modules="modules"
    :slides-per-view="1"
    :space-between="50"
    :pagination="{ clickable: true }"
    @swiper="onSwiper"
    @slideChange="onSlideChange"
  >
    <swiper-slide>
      <p class="title">
        天河分会召开第十四届理事会第十次会议暨第十五届理事会第一次会议
      </p>
      <p class="time">2024-06-12</p>
      <img
        src="../assets/banner.jpg"
        alt="Slide 1"
      />
    </swiper-slide>
    <swiper-slide
      >
      <p class="title">
        天河分会召开第十四届理事会第十次会议暨第十五届理事会第一次会议
      </p>
      <p class="time">2024-06-12</p><img
        src="https://website.cobalt47.cn/zm_wxapp/banner/02.jpg"
        alt="Slide 1"
    /></swiper-slide>
    <swiper-slide
      >
      <p class="title">
        天河分会召开第十四届理事会第十次会议暨第十五届理事会第一次会议
      </p>
      <p class="time">2024-06-12</p><img
        src="https://website.cobalt47.cn/zm_wxapp/banner/03.jpg"
        alt="Slide 1"
    /></swiper-slide>
  </swiper>
</template>
<script>
// import Swiper core and required modules
// import { Pagination} from 'swiper';

// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";

import { Pagination, A11y, Autoplay } from "swiper/modules";
const modules = [Pagination, A11y, Autoplay];

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

// Import Swiper styles
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    const onSwiper = (swiper) => {
      console.log(swiper);
    };
    const onSlideChange = () => {
      console.log("slide change");
    };
    return {
      onSwiper,
      onSlideChange,
      modules,
    };
  },
};
</script>

<style scoped>
.swiper-container {
  width: 100%;
  height: 100%;
  border-radius: 20px;
}
.swiper-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 20px;
}
.swiper-container >>> .swiper-pagination {
  text-align: left !important;
  margin-left: 20px !important;
}
.swiper-container .title {
  position: absolute;
  left: 20px;
  top: 339px;
  width: 760px;
  height: 30px;
  opacity: 1;

  font-family: MiSans;
  font-size: 24px;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0em;

  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  /* 纯白 */
  color: #ffffff;

  text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.5);
}



.swiper-container .time {
  position: absolute;
  left: 20px;
  top: 379px;
  width: 74px;
  height: 19px;
  opacity: 1;

  font-family: MiSans;
  font-size: 14px;
  font-weight: normal;
  line-height: normal;
  letter-spacing: 0em;

  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  /* 纯白 */
  color: #ffffff;
}

.swiper-container .title,.swiper-container .time{
  margin-top:70px;
}
.swiper-container .title,
.swiper-container .time {
  margin-left: 25%;
}
.swiper-container >>> .swiper-pagination{
  margin-left: 26% !important;
  margin-bottom: 30px;
}
</style>